import { Button, Kind } from '@thanx/uikit/button'
import { Modal } from '@thanx/uikit/modal'
import { Switch } from '@thanx/uikit/switch'
import { useStyletron } from '@thanx/uikit/theme'
import { buildTranslate } from 'locales'
import React from 'react'
import { Alert } from 'react-bootstrap'

type Props = {
  isOpen: boolean
  onClose: () => void
  onExclude: () => void
  onInclude: () => void
  isLoading?: boolean
  error?: boolean
}

const t = buildTranslate(
  'thanx_campaigns.builder.include_existing_segment_modal'
)

const IncludeExistingSegmentModal: React.FC<Props> = props => {
  const { isOpen, onClose, onExclude, onInclude, isLoading, error } = props
  const [css] = useStyletron()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="auto"
      closeType="small"
      zIndex={1200}
    >
      <div
        className={`p-xl d-flex flex-column ${css({
          width: '600px',
        })}`}
      >
        <Switch condition={!!error}>
          <Alert bsStyle="danger">{t('error')}</Alert>
        </Switch>
        <h3 className="m-0 grey-90-text">{t('title')}</h3>
        <p className="body-text-4 grey-70-text mt-m mb-xl">
          {t('description')}
        </p>
        <div className="d-flex justify-content-end">
          <Button kind={Kind.SECONDARY} onClick={onExclude} className="mr-m">
            {t('buttons.exclude')}
          </Button>
          <Button onClick={onInclude} isLoading={isLoading}>
            {t('buttons.include')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default IncludeExistingSegmentModal
